<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="cssClass"
  >
    <component :is="type" :fill="fill" />
  </svg>
</template>

<script>
import IconDefaultArrowReturn from '@/components/icon/IconDefaultArrowReturn';
import IconDefaultCalendar from '@/components/icon/IconDefaultCalendar';
import IconDefaultCheck from '@/components/icon/IconDefaultCheck';
import IconDefaultDownload from '@/components/icon/IconDefaultDownload';
import IconDefaultInformationCircle from '@/components/icon/IconDefaultInformationCircle';
import IconDefaultLine3 from '@/components/icon/IconDefaultLine3';
import IconDefaultNewTabLink from '@/components/icon/IconDefaultNewTabLink';
import IconDefaultPlus from '@/components/icon/IconDefaultPlus';
import IconDefaultPlusRectangle from '@/components/icon/IconDefaultPlusRectangle';
import IconDefaultThreeDots from '@/components/icon/IconDefaultThreeDots';
import IconDefaultTrash from '@/components/icon/IconDefaultTrash';
import IconDefaultWarning from '@/components/icon/IconDefaultWarning';
import IconDefaultWarningYellow from '@/components/icon/IconDefaultWarningYellow';

export default {
  props: {
    fill: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    size: {
      type: Number,
      required: false,
      default: 16
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    arrowReturn: IconDefaultArrowReturn,
    calendar: IconDefaultCalendar,
    check: IconDefaultCheck,
    download: IconDefaultDownload,
    informationCircle: IconDefaultInformationCircle,
    line3: IconDefaultLine3,
    newTabLink: IconDefaultNewTabLink,
    plus: IconDefaultPlus,
    plusRectangle: IconDefaultPlusRectangle,
    threeDots: IconDefaultThreeDots,
    trash: IconDefaultTrash,
    warning: IconDefaultWarning,
    warningYellow: IconDefaultWarningYellow
  },
  computed: {
    cssClass() {
      return {
        'c-icon-default': true,
        ['c-icon-default--' + this.type]: this.type
      };
    }
  }
};
</script>
